import { 
    Button, 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    TextField, 
    Stack,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';
import { UserCreation } from '../types/api/User';
import { Role } from '../types/api/Role';

interface UserFormProps {
    open: boolean,
    formMode: 'add' | 'edit',
    close: () => void,
    save: (user: UserCreation) => void,
    baseUser: UserCreation,
    updateUser: (user: UserCreation) => void,
    confirmLabel: string
    roles: Role[]
}

export function UserForm(props: UserFormProps) {
    console.log(props.baseUser)
    return (
        <Dialog 
            slotProps={{ paper: { elevation: 0, sx: { borderRadius: 2 } } }} 
            sx={{ p: { xs: 2, md: 3 } }} 
            open={props.open} 
            maxWidth="sm" 
            fullWidth
        >
            <DialogTitle>
                {props.formMode === 'add' ? 'Créer un utilisateur' : ''}
                {props.formMode === 'edit' ? 'Modifier un utilisateur' : ''}
            </DialogTitle>
            
            <DialogContent>
                <Stack spacing={3} sx={{ pt: 1 }}>
                    <TextField
                        label="Nom"
                        value={props.baseUser.name || ''}
                        onChange={(e) => props.updateUser({
                            ...props.baseUser,
                            name: e.target.value
                        })}
                        fullWidth
                        required
                    />
                    
                    <TextField
                        label="Email"
                        type="email"
                        value={props.baseUser.email || ''}
                        onChange={(e) => props.updateUser({
                            ...props.baseUser,
                            email: e.target.value
                        })}
                        fullWidth
                        required
                    />
                    
                    {props.formMode === 'add' && (
                        <TextField
                            label="Mot de passe"
                            type="password"
                            value={props.baseUser.password || ''}
                            onChange={(e) => props.updateUser({
                                ...props.baseUser,
                                password: e.target.value
                            })}
                            fullWidth
                            required
                        />
                    )}
                    
                    <FormControl fullWidth>
                        <InputLabel id="formation-select-label">Formation</InputLabel>
                        <Select
                            labelId="formation-select-label"
                            value={props.baseUser.role.id || ''}
                            label="Formation"
                            onChange={(e) => props.updateUser({
                                ...props.baseUser,
                                role:{
                                    id: e.target.value as number,
                                    label: e.target.name as string
                                }
                            })}
                            
                        >
                            {props.roles.map((role) => (
                                <MenuItem key={role.id} value={role.id}>
                                    {role.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Stack>
            </DialogContent>
            
            <DialogActions>
                <Button onClick={props.close} color="error">
                    Annuler
                </Button>
                <Button 
                    onClick={() => props.save(props.baseUser)} 
                    variant="contained" 
                    color="primary"
                >
                    {props.confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default UserForm;